
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import {
  DashboardTwoTone,
  ViewTimelineTwoTone,
  MapTwoTone,
  InventoryTwoTone,
  AreaChartTwoTone,
  FolderCopyTwoTone,
  DescriptionTwoTone,
  Settings,
} from '@mui/icons-material';

const createStyledIcon = (IconComponent) => styled(IconComponent)(({ theme }) => ({
  color: theme.palette.primary.light,
}));

// Styled icon components
const StyledDashboard = createStyledIcon(DashboardTwoTone);
const StyledTimeline = createStyledIcon(ViewTimelineTwoTone);
const StyledMap = createStyledIcon(MapTwoTone);
const StyledTasks = createStyledIcon(InventoryTwoTone);
const StyledMetrics = createStyledIcon(AreaChartTwoTone);
const StyledTemplates = createStyledIcon(FolderCopyTwoTone);
const StyledJournal = createStyledIcon(DescriptionTwoTone);

export const DashboardIcon = () => <StyledDashboard />;

export const DashboardSettingsIcon = () => (
  <Box sx={{ position: 'relative', display: 'inline-flex', lineHeight: 0 }}>
    <StyledDashboard />
    <Box
      sx={{
        position: 'absolute',
        bottom: -4,
        right: -4.5,
        width: 14,
        height: 14,
        borderRadius: '50%',
        border: (theme) => `2px solid ${theme.palette.background.paper}`,
        bgcolor: 'secondary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Settings sx={{ fontSize: 9.5, color: '#fff' }} />
    </Box>
  </Box>
);

export const TimelineIcon = () => (
  <StyledTimeline sx={{ transform: 'scaleX(-1)' }} />
);

export const MapIcon = () => <StyledMap />;

export const TasksIcon = () => <StyledTasks />;

export const MetricsIcon = () => <StyledMetrics />;

export const TemplatesIcon = () => <StyledTemplates />;

export const JournalIcon = () => <StyledJournal />;
